import { render, staticRenderFns } from "./ICD10Viewpopup.vue?vue&type=template&id=db8e1bde&scoped=true&"
import script from "./ICD10Viewpopup.vue?vue&type=script&lang=js&"
export * from "./ICD10Viewpopup.vue?vue&type=script&lang=js&"
import style0 from "./ICD10Viewpopup.vue?vue&type=style&index=0&id=db8e1bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e1bde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db8e1bde')) {
      api.createRecord('db8e1bde', component.options)
    } else {
      api.reload('db8e1bde', component.options)
    }
    module.hot.accept("./ICD10Viewpopup.vue?vue&type=template&id=db8e1bde&scoped=true&", function () {
      api.rerender('db8e1bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProblemsIllness/ICD10Viewpopup.vue"
export default component.exports